import { z } from 'zod';
import { FilterOption } from './FilterOption';
// Booking status constants
export const BOOKING_STATUSES = {
    UNCONFIRMED: 'unconfirmed',
    CONFIRMED: 'confirmed',
    UNCONFIRMED_INCOMPLETED: 'unconfirmed_incompleted',
    CANCELLED: 'cancelled',
};
export const BookingStatus = z.enum([
    BOOKING_STATUSES.UNCONFIRMED,
    BOOKING_STATUSES.CONFIRMED,
    BOOKING_STATUSES.UNCONFIRMED_INCOMPLETED,
    BOOKING_STATUSES.CANCELLED,
]);
export const BookingStatusArray = z.array(BookingStatus);
export const BookingStatusFilterOption = FilterOption.refine((option) => Object.values(BOOKING_STATUSES).includes(option.value), 'Invalid booking status value');
export const BookingStatusFilterOptions = z.array(BookingStatusFilterOption);
export const BOOKING_STATUS_OPTIONS = [
    {
        label: 'Unconfirmed',
        value: BOOKING_STATUSES.UNCONFIRMED,
    },
    {
        label: 'Confirmed',
        value: BOOKING_STATUSES.CONFIRMED,
    },
    {
        label: 'Unconfirmed Incompleted',
        value: BOOKING_STATUSES.UNCONFIRMED_INCOMPLETED,
    },
];
export const BOOKING_STATUS_OPTION_KEY = [
    {
        value: 'Unconfirmed',
        key: BOOKING_STATUSES.UNCONFIRMED,
    },
    {
        value: 'Confirmed',
        key: BOOKING_STATUSES.CONFIRMED,
    },
    {
        value: 'Unconfirmed Incompleted',
        key: BOOKING_STATUSES.UNCONFIRMED_INCOMPLETED,
    },
];
export const UNCONFIRMED_BOOKING_STATUSES = [BOOKING_STATUSES.UNCONFIRMED];
// Booking source constants
export const BOOKING_SOURCE_TYPES = {
    PHONE: 'phone',
    EMAIL: 'email',
    WEB: 'web',
    LETTER: 'letter',
    IN_PERSON: 'in_person',
    PA_APP: 'pa_app',
    PA_WEB: 'pa_web',
    STAFF_APP: 'staff_app',
    SOCIAL_MEDIA: 'social_media',
    RETAIL_API: 'retail_api',
};
export const BookingSource = z.enum([
    BOOKING_SOURCE_TYPES.PHONE,
    BOOKING_SOURCE_TYPES.EMAIL,
    BOOKING_SOURCE_TYPES.WEB,
    BOOKING_SOURCE_TYPES.LETTER,
    BOOKING_SOURCE_TYPES.IN_PERSON,
    BOOKING_SOURCE_TYPES.PA_APP,
    BOOKING_SOURCE_TYPES.PA_WEB,
    BOOKING_SOURCE_TYPES.STAFF_APP,
    BOOKING_SOURCE_TYPES.SOCIAL_MEDIA,
    BOOKING_SOURCE_TYPES.RETAIL_API,
]);
export const BookingSourceArray = z.array(BookingSource);
export const BOOKING_SOURCES = [
    {
        value: 'Phone',
        key: BOOKING_SOURCE_TYPES.PHONE,
    },
    {
        value: 'Email',
        key: BOOKING_SOURCE_TYPES.EMAIL,
    },
    {
        value: 'Web',
        key: BOOKING_SOURCE_TYPES.WEB,
    },
    {
        value: 'Letter',
        key: BOOKING_SOURCE_TYPES.LETTER,
    },
    {
        value: 'In Person',
        key: BOOKING_SOURCE_TYPES.IN_PERSON,
    },
    {
        value: 'Passenger Assistance APP',
        key: BOOKING_SOURCE_TYPES.PA_APP,
    },
    {
        value: 'Passenger Assistance WEB',
        key: BOOKING_SOURCE_TYPES.PA_WEB,
    },
    {
        value: 'Staff Mobile App',
        key: BOOKING_SOURCE_TYPES.STAFF_APP,
    },
    {
        value: 'Social Media',
        key: BOOKING_SOURCE_TYPES.SOCIAL_MEDIA,
    },
    {
        value: 'Retail API',
        key: BOOKING_SOURCE_TYPES.RETAIL_API,
    },
];
// Booking type constants
export const BOOKING_TYPE_VALUES = {
    PRE_BOOKED: 'Pre-booked',
    UNBOOKED: 'Unbooked',
    TUAG: 'TUAG',
    POST_DEPARTURE: 'Post departure',
};
export const BookingType = z.enum([
    BOOKING_TYPE_VALUES.PRE_BOOKED,
    BOOKING_TYPE_VALUES.UNBOOKED,
    BOOKING_TYPE_VALUES.TUAG,
    BOOKING_TYPE_VALUES.POST_DEPARTURE,
]);
export const BookingTypeArray = z.array(BookingType);
export const BOOKING_TYPE_OPTION = [
    { key: BOOKING_TYPE_VALUES.PRE_BOOKED, value: BOOKING_TYPE_VALUES.PRE_BOOKED },
    { key: BOOKING_TYPE_VALUES.UNBOOKED, value: BOOKING_TYPE_VALUES.UNBOOKED },
    { key: BOOKING_TYPE_VALUES.TUAG, value: BOOKING_TYPE_VALUES.TUAG },
    { key: BOOKING_TYPE_VALUES.POST_DEPARTURE, value: BOOKING_TYPE_VALUES.POST_DEPARTURE },
];
